import { Theme } from '@/theme';
import Logo from '@CS/assets/logo-en.png';
import styled, { css } from 'styled-components';

// If set to `true`, AppWrapper will remove "overflow-y: auto;"
// and set both axis to "hidden". Default is `false`:
type AppWrapperAttributes = {
  $landscape?: boolean;
  $overflow?: boolean;
};

export const AppWrapper = styled.div<AppWrapperAttributes>(
  ({ $landscape, $overflow }) => css`
    background-color: ${Theme.color.lightPurple};
    background-blend-mode: soft-light;

    background-image: radial-gradient(
      79.23% 20.32% at 50% 51.95%,
      rgb(255 255 255 / 0.5) 0%,
      rgb(255 255 255 / 0) 100%
    );

    justify-content: center;
    flex-direction: column;
    overflow: hidden auto;

    align-items: center;
    min-height: 100dvh;
    isolation: isolate;
    position: relative;

    ${$landscape &&
    css`
      --minWidth: 568px;
      --maxWidth: 932px;
    `}

    display: flex;
    height: 100%;
    width: 100%;

    &::after {
      background-image: url('${Logo}');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      width: calc(100% - 10px);
      position: absolute;

      margin: auto;
      height: auto;

      z-index: -1;
      content: '';
      inset: 0px;
    }

    ${$overflow &&
    css`
      overflow: hidden;
    `}
  `
);

// If set to `false`, ContentWrapper will use full
// screen width on tablet devices. Default is `true`:
type ContentWrapperAttributes = {
  $clamp?: boolean;
  lang?: string;
};

export const ContentWrapper = styled.div<ContentWrapperAttributes>(
  ({ $clamp = true, lang }) => css`
    min-height: 100dvh;
    position: relative;

    margin: 0px auto;
    display: block;

    height: 100%;
    width: 100%;

    ${$clamp &&
    css`
      max-width: ${Screen.MAX};
    `}

    ${lang === 'ar' &&
    css`
      span,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      a {
        direction: rtl;
      }
    `}
  `
);

export const ScreenWrapper = styled.section`
  justify-content: center;
  flex-direction: column;

  align-items: center;
  position: relative;

  min-height: 100dvh;
  max-width: 100vw;

  margin: 0 auto;
  display: flex;

  height: 100%;
  width: 100%;
`;

export enum Screen {
  // Portrait:
  MIN = '320px',
  MAX = '932px'

  // Landscape:
  // MIN = '568px',
  // MAX = '932px'
}

export enum zIndex {
  MIN = -2147483648,
  MAX = 2147483647
}
